import React, { FC } from 'react';

interface Props {
    btnClass?: string;
    btnStr?: string;
    boxClass?: string;
    noBtn?: boolean;
    ariaLabel?: string;
    children: React.ReactNode;
}
/**
 *
 * @param btnClass 버튼 추가 클래스
 * @param btnStr 히든 버튼 명
 * @param boxClass 박스 클래스명
 * @returns TextCloud
 */
export const TextCloud: FC<Props> = ({
    btnClass,
    btnStr,
    boxClass,
    noBtn,
    ariaLabel,
    children,
}) => {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        const element = document.querySelector('.textCloud') as HTMLElement;
        const btnElement = document.querySelector('.textCloud-btn') as HTMLElement;
        if (element && !isVisible) {
            element.style.display = 'none !important';
        }
        if (btnElement && !isVisible) {
            btnElement.blur();
        }
    }, [isVisible]);

    const handleTrue = () => {
        setIsVisible(true);
    };
    const handleFalse = () => {
        setIsVisible(false);
    };

    return (
        <div className="textCloud-wrap" onMouseEnter={handleTrue} onMouseLeave={handleFalse}>
            {noBtn ? (
                <span
                    className={`textCloud-btn ${btnClass || ''}`}
                    tabIndex={0}
                    aria-label={ariaLabel}
                >
                    <span className="sr-only">{btnStr}</span>
                </span>
            ) : (
                <button
                    type="button"
                    className={`textCloud-btn ${btnClass || ''}`}
                    aria-label={ariaLabel}
                >
                    <span className="sr-only">{btnStr}</span>
                </button>
            )}
            <div className={`textCloud ${boxClass || ''}`}>{children}</div>
        </div>
    );
};
